<div class="rounded-corners">
  <table mat-table [dataSource]="tableData" cdkDropList cdkDropListOrientation="horizontal" multiTemplateDataRows>
    <!-- Loop columnsToDisplay array -->
    @for (column of displayedColumns; track column) {
      <ng-container [matColumnDef]="column.columnName">
        <!-- HEADER -->
        @if (column.columnName !== 'actions') {
          <th mat-header-cell cdkDrag *matHeaderCellDef translate="Table.{{column.transTag}}"
          class="col-{{column.noOfColumns}}"></th>
        }
        @if (column.columnName === 'actions') {
          <th mat-header-cell cdkDrag *matHeaderCellDef class="col-1">
            @if (allowedToDoAction()) {
              <button type="button" (click)="$event.stopPropagation();" class="float-end btn statusheader action-button border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-three-dots bi-large"></i>
              </button>
            }
            <div class="float-end">
              <ul class="dropdown-menu w-auto">
                @if (downloadAllowed()) {
                  <li ><a class="dropdown-item" (click)="performActionForAnId(requestStatusActionsEnum.Download)" translate="Request.Status.RequestOptions.DownloadRequest"></a></li>
                }
                @if (exportAllowed() && showMSplugins) {
                  <li><a class="dropdown-item" (click)="performActionForAnId(requestStatusActionsEnum.Export)" translate="Request.Status.RequestOptions.ExportRequest"></a></li>
                }
              </ul>
            </div>
          </th>
        }
        <!-- BODY -->
        @if (column.columnName !== 'actions') {
          <td mat-cell *matCellDef="let document" class="col-{{column.noOfColumns}}">
            {{ document[column.columnName] | valueByTypePipe : column.type }}
            <!-- Add copy to clipboard function, based on datatype Guid -->
            @if (column.type === 'Guid') {
              <em class="bi bi-copy cursor-pointer copy-icon" aria-hidden="true" (click)="copyToClipboard(document[column.columnName])"></em>
            }
          </td>
        }
        @if (column.columnName === 'actions') {
          <td mat-cell *matCellDef="let document" class="col-{{column.noOfColumns}}">
            <span class="float-end">
              <button type="button" (click)="$event.stopPropagation();" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-three-dots bi-large"></i>
              </button>
              <ul class="dropdown-menu">
                @if (openPreviewAllowed() && document.documentType !== 'JsonSignature' && isPossibleToViewRendering(document)) {
                  <li>
                    <a class="dropdown-item pt-1 pb-1" (click)="$event.stopPropagation(); performActionForAnId(requestStatusActionsEnum.openPreview, null, document.identifier)"
                    translate="Request.Status.DocumentOptions.ShowDocument"></a>
                  </li>
                }
                <li>
                  <a class="dropdown-item pt-1 pb-1" (click)="$event.stopPropagation(); performActionForAnId(requestStatusActionsEnum.showDocumentDetails, null, document.identifier)"
                  translate="Request.Status.DocumentOptions.ShowDocumentDetails"></a>
                </li>
                <li>
                  @if (editFilingDataAllowed()) {
                    <a class="dropdown-item pt-1 pb-1" (click)="$event.stopPropagation(); performActionForAnId(requestStatusActionsEnum.EditFilingData, null, document.identifier)"
                    translate="Request.Status.DocumentOptions.EditFilingData"></a>
                  }
                </li>
                <li>
                  <a class="dropdown-item pt-1 pb-1" (click)="$event.stopPropagation(); performActionForAnId(requestStatusActionsEnum.DownloadDocument, null, document.identifier)"
                  translate="Request.Status.DocumentOptions.DownloadDocument"></a>
                </li>
                <li>
                  <a class="dropdown-item pt-1 pb-1" (click)="$event.stopPropagation(); performActionForAnId(requestStatusActionsEnum.ExportDocument, null, document.identifier)"
                  translate="Request.Status.DocumentOptions.ExportDocument"></a>
                </li>
              </ul>
            </span>
          </td>
        }
      </ng-container>
    }
    <!-- Display data and declare specific embedded component -->
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"
      [ngClass]="{'cursor-pointer': openPreviewDocumentAllowed(row)}"
      (click)="openPreviewDocumentAllowed(row) ? performActionForAnId(requestStatusActionsEnum.openPreview, null, row.identifier) : null">
    </tr>
  </table>
</div>